import React, { useEffect, useState, useContext } from "react";
import * as notify from "../../shared/notify";

import UpcList from "./components/upc-list";
import SearchInput from "./components/search-input";
import SubmitStatus from "./components/status";
import RepostOptions from "../upc-search/repost-options";
import { getProducts, resubmitTask } from "./lib/resubmitData";
import { ViewOnlyPermissionsContext } from "contexts/view-only-permissions/view-only-permissions";
import { compact } from "lodash";

const DEFAULT_REDO_PRODUCT = { destinations: [], shouldUpdatePostDate: true, sendToGdsn: false };

const ResubmitUpcIndex = () => {
    const { viewOnlyAdmin } = useContext(ViewOnlyPermissionsContext);
    const [upcList, setUpcList] = useState([]);
    const [clearSelectedUpcs, setClearSelectedUpcs] = useState(false);
    const [resetUpcValues, setResetUpcValues] = useState(false);
    const [disableResubmit, setDisableResubmit] = useState(false);
    const [results, setResults] = useState([]);
    const [repostOptions, setRepostOptions] = useState({ ...DEFAULT_REDO_PRODUCT });

    useEffect(() => {
        if (clearSelectedUpcs) {
            setClearSelectedUpcs(false);
        }

        if (resetUpcValues) {
            setResetUpcValues(false);
        }
    }, [resetUpcValues, clearSelectedUpcs]);

    const searchUpcs = async (upcValues) => {
        if (!upcValues) {
            notify.error("Please enter at least 1 upc");
            setUpcList([]);

            return;
        }

        const upcs = compact(upcValues.replace(/[,\s\n\r]+/g, " ").split(" "));
        const products = await getProducts(upcs);
        setClearSelectedUpcs(true);

        if (products.length <= 0) {
            notify.error("No results found");
        }

        setUpcList(products);
        setResults([]);
    };

    const updateUpc = (upc) => {
        const data = upcList.map((u) => {
            if (upc.key === u.key) {
                return upc;
            }

            return u;
        });
        setUpcList(data);
    };

    const resubmitUpc = async (resubmitKeys) => {
        if (resubmitKeys.length === 0) {
            notify.warning("You must select at least one upc to resubmit.");

            return false;
        }

        if (!repostOptions.destination || repostOptions.destination.length === 0) {
            notify.error("At least one destination is required");

            return false;
        }

        const submitData = await resubmitTask(resubmitKeys, repostOptions.destination, repostOptions.shouldUpdatePostDate, repostOptions.sendToGdsn);

        if (!submitData) {
            return false;
        }

        if (submitData.success === false) {
            return notify.error("You do not have permission to perform this action.");
        }

        setUpcList([]);
        setResults(submitData.items);
        setResetUpcValues(true);

        return true;
    };

    const updateRepostOptions = (data) => {
        setRepostOptions(data);
    };

    return (
        <div>
            <h1>Resubmit UPC</h1>
            <div className="row">
                <div className="column -span6">
                    <SearchInput searchUpcs={searchUpcs} resetUpcValues={resetUpcValues} />
                </div>
                <div className="column -span6">
                    <RepostOptions
                        disable={null}
                        updateData={updateRepostOptions}
                        disableWithUpdate={viewOnlyAdmin.resubmitWithUpdate}
                        disableWithoutUpdate={viewOnlyAdmin.resubmitWithoutUpdate}
                        setDisableResubmit={setDisableResubmit}
                    />
                </div>
            </div>

            <UpcList updateUpc={updateUpc} upcList={upcList} resubmitUpc={resubmitUpc} clearSelected={clearSelectedUpcs} disabled={disableResubmit} />
            {results && results.length > 0 && <SubmitStatus data={results} />}
        </div>
    );
};

export default ResubmitUpcIndex;
